export function getBaseUrl() {
  return typeof process === "undefined" ||
    typeof process.env === "undefined" ||
    typeof process.env.VERCEL_URL === "undefined"
    ? "http://localhost:4007"
    : "https://" + process.env.VERCEL_URL
}

type VideoMetaData = {
  name: string
  description: string
  coverUrl: string
  videoUrl: string
  providerName?: string | null
  systemVersion?: string | null
  creationTimestamp?: string | null
  lessonId?: number | null
  createdBy?: string | null
  id: string
}

export function buildVideoMeta(
  url: string,
  videoContentType: "video/mp4" | "text/html",
  data: VideoMetaData
) {
  const aiModified =
    data.createdBy === "created-ai" || data.createdBy === "modified-ai"
  return [
    {
      title:
        data.name +
        (aiModified
          ? ` - ${data.createdBy === "created-ai" ? "Created" : "Modified"} with AI`
          : ""),
    },
    { name: "description", content: data.description },
    { property: "og:title", content: data.name },
    { property: "og:description", content: data.description },
    { property: "al:web:url", content: url },
    { property: "og:image", content: data.coverUrl },
    { property: "og:image:width", content: "720" },
    { property: "og:image:height", content: "480" },
    { property: "og:url", content: url },
    { property: "og:type", content: "video.other" },
    { property: "og:site_name", content: "DPro by Data Protocol" },
    { property: "og:video", content: data.videoUrl },
    { property: "og:video:url", content: data.videoUrl },
    { property: "og:video:secure_url", content: data.videoUrl },
    { property: "og:video:type", content: videoContentType },
    { property: "og:video:width", content: "720" },
    { property: "og:video:height", content: "480" },
    { property: "og:video:tag", content: "DPro" },
    { property: "og:video:tag", content: "Data Protocol" },
    { property: "twitter:card", content: "player" },
    { property: "twitter:site", content: "@dataprotocol" },
    { property: "twitter:url", content: url },
    { property: "twitter:title", content: data.name },
    { property: "twitter:description", content: data.description },
    { property: "twitter:image", content: data.coverUrl },
    { property: "twitter:player", content: data.videoUrl },
    { property: "twitter:player:width", content: "720" },
    { property: "twitter:player:height", content: "480" },
    { property: "twitter:player:stream", content: data.videoUrl },
    {
      property: "twitter:player:stream:content_type",
      content: videoContentType,
    },
    ...(aiModified
      ? [
          { name: "ai:provider", content: data.providerName },
          { name: "ai:system_version", content: data.systemVersion },
          { name: "ai:creation_timestamp", content: data.creationTimestamp },
          {
            name: "ai:identifier",
            content: `https://video.dataprotocol.com/embed/${data.id}`,
          },
        ]
      : []),
  ]
}

// eslint-disable-next-line
export function debounceFunc(fn: Function, ms = 300) {
  let timeoutId: ReturnType<typeof setTimeout>
  // eslint-disable-next-line
  return function (this: any, ...args: any[]) {
    clearTimeout(timeoutId)
    timeoutId = setTimeout(() => fn.apply(this, args), ms)
  }
}
